import { SERVER_URL } from '../SharedCommon/utils';

interface IOrg {
  prefix?: string;
  orgId: number;
  classProgressionControl?: boolean;
  orgServerUrl?: string;
}

const fishMeetMeta: IOrg = {
  prefix: 'fishmeet',
  // Todo: If fishmeet's orgId is confirmed, deleted this comment
  orgId: 17,
  classProgressionControl: true
};

const orgList: IOrg[] = [
  {
    prefix: 'www',
    orgId: 0
  },
  {
    orgId: 1,
    classProgressionControl: true
  },
  {
    prefix: 'xwa',
    orgId: 11,
    orgServerUrl: SERVER_URL + '/api-xwa'
  },
  {
    prefix: 'enyan',
    orgId: 12,
    classProgressionControl: true
  },
  /* boteli is not using it..., so give this domain back to general use
  ,
  {
    prefix: 'boteli',
    orgId: 13,
    classProgressionControl: true
  }
  */
  {
    prefix: 'hsf',
    orgId: 15,
    classProgressionControl: true,
    orgServerUrl: SERVER_URL + '/api-xwa'
  },
  {
    prefix: 'giu',
    orgId: 16,
    classProgressionControl: true
  },
  fishMeetMeta
];

export function getOrgServer(id: number) {
  if (!id) {
    return undefined;
  }

  const org = orgList.find((org) => org.orgId === id);
  if (!org) {
    return undefined;
  }
  return org.orgServerUrl;
}

export function getOrgClassProgressionControl(id: number) {
  const org = orgList.find((org) => org.orgId === id);
  if (!org) {
    return false;
  }
  return !!org.classProgressionControl;
}

export function getOrgIdFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const hostname = window.location.hostname;
  const testOrgParam = params.get('testorg');
  if (testOrgParam) {
    const testOrgId = parseInt(testOrgParam, 10);
    if (!isNaN(testOrgId)) {
      return testOrgId;
    }
  }

  const org = orgList.find(
    (org) => !!org.prefix && (hostname.startsWith(org.prefix) || params.get(org.prefix) === '1')
  );
  return org ? org.orgId : 0;
}
